import React, { useState } from "react";
import FormWrapper from "../../components/Timesheet/FormWrapper";
import TimeSheetDate from "../../components/Timesheet/TimeSheetDate";
import history from "../../routes/history";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { configTimeSheetInit } from "../../redux/actions";

const TimeSheetStartDate = () => {
  const { StartDate = moment() } = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const configTimeSheetReducer = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const getPreviousSetValue = () => {
    const startDate = StartDate ? moment(StartDate, "YYYY-MM-DD") : null;
    return startDate &&
      startDate.isSameOrAfter(moment().subtract(1, "month").startOf("day"))
      ? startDate
      : moment().startOf("day");
  };
  const [selectedDate, setSelectedDate] = useState(getPreviousSetValue());

  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch(configTimeSheetInit({ StartDate: selectedDate }));
    history.push("/end-date");
  };

  return (
    <FormWrapper
      pageTitle={"Configure Timesheet"}
      percent={20}
      nextFunction={() => handleNext()}
      backFunction={() => history.goBack()}
    >
      <TimeSheetDate
        label="Start Date"
        selectedDate={moment(selectedDate)}
        handleDateChange={(date) => {
          setSelectedDate(date.format("YYYY-MM-DD"));
        }}
        showError={false}
        handleDisableDate={(date) =>
          date && date.isBefore(moment().subtract(1, "month").startOf("day"))
        }
      />
    </FormWrapper>
  );
};

export default TimeSheetStartDate;
